// Lokalny development: http://localhost:8080/api
// Produkcja: https://playsportusa.herokuapp.com/api
const url = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

export default url;
